<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  color="blue"
                  :link="true"
                  target="_blank"
                  :to="getRoute(row.data.item)"
                >
                  <v-icon color="blue">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("View") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="unlock(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-lock-open</v-icon>
                </a>
              </template>
              <span>{{ $t("Unblock") }}</span>
            </v-tooltip>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentService from "@/services/DocumentService";
import SearchType from "@/ecm/variables/SearchType";

export default {
  data() {
    return {
      title: this.$t("LockedDocuments"),
      grid: {
        key: "lockedDocumentsGrid",
        dataSource: DocumentService.getLockedGrid(),
        columns: [
          {
            field: "ContentType",
            caption: this.$t("ContentType"),
            type: "string",
          },
          {
            field: "UserName",
            caption: this.$t("User"),
            type: "string",
          },
          {
            field: "FormattedLockDate",
            caption: this.$t("Date"),
            type: "string",
          },
        ],
      },
    };
  },
  computed: {
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    unlock(dto) {
      DocumentService.unlock([dto.Id]).then((result) => {
        this.gridInstance.refresh();
      });
    },
    getRoute(dto) {
      var pattern = {
        searchPattern: dto.Id,
        searchAllVersions: true,
      };
      var route = `/search/${SearchType.DocumentIDs}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
      return route;
    },
  },
};
</script>
